import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
function StatCard({
  bgColor,
  Icon,
  iconColor,
  value,
  caption
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: bgColor,
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 3
  }, /*#__PURE__*/React.createElement(Icon, {
    sx: {
      color: iconColor
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontWeight: 700,
    variant: "h5"
  }, value !== undefined ? value : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, caption));
}
export default StatCard;